import styles from "./index.module.scss";

export default function Windy({ url }: { url: string }): JSX.Element {
  return (
    <div className={styles.windyEmbed__container}>
      <iframe className={styles.windyEmbed__iframe} src={url} title=""></iframe>
    </div>
  );
}
